import { setEligibleProducts } from 'reducers/productReducer';
import { getEligibleProducts } from 'services/product-catalogue/getEligibleProducts';
import { setLoader } from 'reducers/appConfigReducer';
import { AppDispatch } from 'store';
import { closeModal, openModal } from '../reducers/modalReducer';

export const getProductsThunk =
  (brUid: string | undefined, partnerId: string | undefined) => (dispatch: AppDispatch) => {
    dispatch(
      setLoader({
        loading: true,
        message: 'Loading Eligible Products...',
      }),
    );
    if (brUid === '') {
      brUid = undefined;
      console.log('brUid is undefined');
    }

    if (partnerId === '') {
      partnerId = undefined;
      console.log('partnerId is undefined');
    }

    if (partnerId) {
      console.log('partnerId is defined -> requesting partner eligible products');
    } else {
      console.log('partnerId is undefined -> requesting br eligible products');
    }

    return getEligibleProducts(brUid)
      .then((response) => {
        dispatch(
          setLoader({
            loading: false,
            message: '',
          }),
        );
        dispatch(setEligibleProducts(response.products ?? []));
        dispatch(
          setLoader({
            loading: false,
            message: '',
          }),
        );
      })
      .catch((error) => {
        dispatch(
          openModal({
            modalType: 'JBErrorModalWrapper',
            modalProps: {
              httpError: error,
              okHandler: () => {
                dispatch(closeModal());
              },
              technicalInfo: {
                title: 'Error when retrieving eligible products',
                userErrorMessage: 'An error occurred when retrieving eligible products. Please try again later.',
              },
            },
          }),
        );
        dispatch(
          setLoader({
            loading: false,
            message: '',
          }),
        );
        return;
      });
  };
